import Vue from 'vue'
import { getAction, deleteAction, putAction, postAction, httpAction } from '@/api/manage'
import { UI_CACHE_DB_DICT_DATA } from '@/store/mutation-types'
import { MTC_AUTH } from '@api/servers'

// 附件上传
export const fileUpload = `${window._CONFIG.domianURL}${ MTC_AUTH }sys/common/upload`
// 获取所有后端配置的多语言项
export const getLangList = params => getAction(`${ MTC_AUTH }language/sysLanguageConfigFile/allList`, params)
// 获取数据源
export const dataSourceOptions = () => getAction(`${MTC_AUTH}sys/dataSource/options`)

//角色管理
// 指定用户查看部门信息
export const userDepartList = params => getAction(`${ MTC_AUTH }sys/user/userDepartList`, params)
export const addRole = params => postAction(`${ MTC_AUTH }sys/role/add`, params)
export const editRole = params => putAction(`${ MTC_AUTH }sys/role/edit`, params)
export const checkRoleCode = params => getAction(`${ MTC_AUTH }sys/role/checkRoleCode`, params)
export const queryall = params => getAction(`${ MTC_AUTH }sys/role/queryall`, params)
// 查询职务信息
export const positionList = params => getAction(`${ MTC_AUTH }sys/position/list`, params)
export const queryByOrgCodeForAddressList = params => getAction(`${ MTC_AUTH }sys/user/queryByOrgCodeForAddressList`, params)
//用户管理
export const tenantUserId = params => getAction(`${ MTC_AUTH }sys/tenant/queryTenantByUserId`, params)
export const addUser = params => postAction(`${ MTC_AUTH }sys/user/add`, params)
export const editUser = params => putAction(`${ MTC_AUTH }sys/user/edit`, params)
export const queryUserRole = params => getAction(`${ MTC_AUTH }sys/user/queryUserRole`, params)
export const queryUserCategory = params => getAction(`${ MTC_AUTH }sys/user/queryUserCategory`, params)
export const getUserList = params => getAction(`${ MTC_AUTH }sys/user/list`, params)
export const frozenBatch = params => putAction(`${ MTC_AUTH }sys/user/frozenBatch`, params)
export const getAllUserList = params => getAction(`${ MTC_AUTH }sys/user/getAllUserList`, params)
export const getPlantAndCompanyCode = params => getAction(`${ MTC_AUTH }sys/user/getPlantAndCompanyCode`, params)
export const getCurrentUser = params => getAction(`${ MTC_AUTH }sys/user/getCurrentUser`, params)
export const getCurrentCompany = params => getAction(`${ MTC_AUTH }sys/user/getCurrentCompany`, params)
//验证用户是否存在
export const checkOnlyUser = params => getAction(`${ MTC_AUTH }sys/user/checkOnlyUser`, params)
//改变密码
export const changePassword = params => putAction(`${ MTC_AUTH }sys/user/changePassword`, params)
// 获取语言下拉框list
export const sysLanguageConfiguration = () => getAction(`${ MTC_AUTH }system/sysLanguageConfiguration/selectList`)
// 获取主语言和副语言
export const mainLanguageAndSecondLanguage = () => getAction(`${ MTC_AUTH }sys/user/getMainLanguageAndSecondLanguage`)
// 获取多语言字段
export const listDisposition = params => getAction(`${ MTC_AUTH }system/sysLanguage/listDisposition`, params)
// 获取指定字段多语言详情
export const queryFiledLanguageList = params => getAction(`${ MTC_AUTH }system/sysLanguage/queryFiledLanguageList`, params)
// 根据业务数据id获取列表数据多语言
export const listByBizId = params => postAction(`${ MTC_AUTH }system/sysLanguage/listByBizId`, params)
// 设置次语言
export const setLanguage = params => putAction(`${ MTC_AUTH }sys/user/setMainLanguageAndSecondLanguage`, params)
export const randomImage = params => getAction(`${ MTC_AUTH }sys/randomImage/${params}`)
//权限管理
export const addPermission = params => postAction(`${ MTC_AUTH }sys/permission/add`, params)
export const editPermission = params => putAction(`${ MTC_AUTH }sys/permission/edit`, params)
export const getPermissionList = params => getAction(`${ MTC_AUTH }sys/permission/list`, params)
export const getSystemMenuList = params => getAction(`${ MTC_AUTH }sys/permission/getSystemMenuList`, params)
export const getSystemSubmenu = params => getAction(`${ MTC_AUTH }sys/permission/getSystemSubmenu`, params)
export const getSystemSubmenuBatch = params => getAction(`${ MTC_AUTH }sys/permission/getSystemSubmenuBatch`, params)
export const queryTreeList = params => getAction(`${ MTC_AUTH }sys/permission/queryTreeList`, params)
export const queryTreeListForRole = params => getAction(`${ MTC_AUTH }sys/role/queryTreeList`, params)
export const queryListAsync = params => getAction(`${ MTC_AUTH }sys/permission/queryListAsync`, params)
export const queryRolePermission = params => getAction(`${ MTC_AUTH }sys/permission/queryRolePermission`, params)
// 获取可以给租户分配的可复制菜单
export const getCopyMenu = params => getAction(`${ MTC_AUTH }sys/permission/getCopyMenu`, params)
// 引导式新建租户
export const tenantAdd = params => postAction(`${MTC_AUTH}sys/tenant/add`, params)
// 租户列表
export const tenantList = params => getAction(`${MTC_AUTH}sys/tenant/list`, params)
// 分配租户保存
export const tenantDistributionSave = params => getAction(`${MTC_AUTH}`, params)
export const saveRolePermission = params => postAction(`${ MTC_AUTH }sys/permission/saveRolePermission`, params)
export const queryPermissionsByUser = params => getAction(`${ MTC_AUTH }sys/permission/getUserPermissionByToken`, params)
export const loadAllRoleIds = params => getAction(`${ MTC_AUTH }sys/permission/loadAllRoleIds`, params)
export const getPermissionRuleList = params => getAction(`${ MTC_AUTH }sys/permission/getPermRuleListByPermId`, params)
export const queryPermissionRule = params => getAction(`${ MTC_AUTH }sys/permission/queryPermissionRule`, params)
// 部门管理
export const queryDepartTreeList = params => getAction(`${ MTC_AUTH }sys/sysDepart/queryTreeList`, params)
export const queryTreeListByPermission = params => getAction(`${ MTC_AUTH }sys/sysDepart/queryTreeListByPermission`, params)
export const queryIdTree = params => getAction(`${ MTC_AUTH }sys/sysDepart/queryIdTree`, params)
export const queryParentName = params => getAction(`${ MTC_AUTH }sys/sysDepart/queryParentName`, params)
export const searchByKeywords = params => getAction(`${ MTC_AUTH }sys/sysDepart/searchBy`, params)
export const deleteByDepartId = params => deleteAction(`${ MTC_AUTH }sys/sysDepart/delete`, params)
export const queryDeptListByParam = params => getAction(`${ MTC_AUTH }sys/sysDepart/queryDeptListByParam`, params)
export const getFarmListByDes = params => getAction(`${ MTC_AUTH }sys/sysDepart/getFarmListByDes`, params)
//获取部门有权限
export const getCompanyListByPermission = params => getAction(`${ MTC_AUTH }sys/sysDepart/getDepartListByPermission`, params)
// export const getFarmListByPermission = params => {
//   params = params || {}
//   params[ 'orgCategory' ] = '5'
//   return getAction(`${ MTC_AUTH }sys/sysDepart/getDepartListByPermission`, params)
// }
// export const getFarmOrFwzListByPermission = params => {
//   params = params || {}
//   params[ 'orgCategoryList' ] = '2,5'
//   return getAction(`${ MTC_AUTH }sys/sysDepart/getDepartListByPermission`, params)
// }
export const getCompanyListNoPermission = params => {
  params = params || {}
  params[ 'orgCategory' ] = '1'
  getAction(`${ MTC_AUTH }sys/sysDepart/getDepartListByNoPermission`, params)
}
export const getFarmListNoPermission = () => getAction(`${ MTC_AUTH }sys/sysDepart/getDepartListByNoPermission`, { orgCategory: '5' })
export const getFarmOrFwzListNoPermission = () => getAction(`${ MTC_AUTH }sys/sysDepart/getDepartListByNoPermission`, { orgCategoryList: '2,5' })
// 部门扩展信息
export const queryDepartExtend = params => getAction(`${ MTC_AUTH }sys/sysDepartExtend/queryById`, params)
//二级部门管理
export const queryDepartPermission = params => getAction(`${ MTC_AUTH }sys/permission/queryDepartPermission`, params)
export const saveDepartPermission = params => postAction(`${ MTC_AUTH }sys/permission/saveDepartPermission`, params)
export const queryTreeListForDeptRole = params => getAction(`${ MTC_AUTH }sys/sysDepartPermission/queryTreeListForDeptRole`, params)
export const queryDeptRolePermission = params => getAction(`${ MTC_AUTH }sys/sysDepartPermission/queryDeptRolePermission`, params)
export const saveDeptRolePermission = params => postAction(`${ MTC_AUTH }sys/sysDepartPermission/saveDeptRolePermission`, params)
export const queryMyDepartTreeList = params => getAction(`${ MTC_AUTH }sys/sysDepart/queryMyDeptTreeList`, params)
// 设备列表右侧树接口
export const queryMyDistDeptTreeList = params => getAction(`${ MTC_AUTH }sys/sysDepart/queryMyDistDeptTreeList`, params)
// 部门权限设置
export const departRoleList = params => getAction(`${MTC_AUTH}sys/sysDepartRole/list`, params)
export const departRoleDelete = params => getAction(`${MTC_AUTH}sys/sysDepartRole/delete`, params)
export const departRoleBatchDelete = params => getAction(`${MTC_AUTH}sys/sysDepartRole/deleteBatch`, params)

//日志管理
export const deleteLog = params => deleteAction(`${ MTC_AUTH }sys/log/delete`, params)
export const deleteLogList = params => deleteAction(`${ MTC_AUTH }sys/log/deleteBatch`, params)
//数据字典
export const addDict = params => postAction(`${ MTC_AUTH }sys/dict/add`, params)
export const editDict = params => putAction(`${ MTC_AUTH }sys/dict/edit`, params)
export const treeList = params => getAction(`${ MTC_AUTH }sys/dict/treeList`, params)
export const addDictItem = params => postAction(`${ MTC_AUTH }sys/dictItem/add`, params)
export const editDictItem = params => putAction(`${ MTC_AUTH }sys/dictItem/edit`, params)
//字典标签专用（通过code获取字典数组）
export const ajaxGetDictItems = ( code, params ) => getAction(`${ MTC_AUTH }sys/dict/getDictItems/${ code }`, params)
//从缓存中获取字典配置
export const getDictItemsFromCache = ( dictCode ) => {
  if (Vue.ls.get(UI_CACHE_DB_DICT_DATA) && Vue.ls.get(UI_CACHE_DB_DICT_DATA)[ dictCode ]) {
    let dictItems = Vue.ls.get(UI_CACHE_DB_DICT_DATA)[ dictCode ]
    // console.log(`-----------getDictItemsFromCache----------dictCode=` + dictCode + `---- dictItems=`, dictItems)
    return dictItems
  }
}
//系统通告
export const doReleaseData = params => getAction(`${ MTC_AUTH }sys/annountCement/doReleaseData`, params)
export const doReovkeData = params => getAction(`${ MTC_AUTH }sys/annountCement/doReovkeData`, params)
//获取系统访问量
export const getLoginfo = params => getAction(`${ MTC_AUTH }sys/loginfo`, params)
export const getVisitInfo = params => getAction(`${ MTC_AUTH }sys/visitInfo`, params)
// 根据部门主键查询用户信息
export const queryUserByDepId = params => getAction(`${ MTC_AUTH }sys/user/queryUserByDepId`, params)
// 重复校验
export const duplicateCheck = params => getAction(`${ MTC_AUTH }sys/duplicate/check`, params)
// 双字段联合数据重复校验
export const duplicateCheckTwoCol = params => getAction(`${ MTC_AUTH }sys/duplicate/checkTwoCol`, params)
// 加载分类字典
export const loadCategoryData = params => getAction(`${ MTC_AUTH }sys/category/loadAllData`, params)
export const checkRuleByCode = params => getAction(`${ MTC_AUTH }sys/checkRule/checkByCode`, params)
export const getSysCategoryByParams = params => getAction(`${ MTC_AUTH }sys/category/getSysCategoryByParams`, params)
//我的通告
export const getUserNoticeInfo = params => getAction(`${ MTC_AUTH }sys/sysAnnouncementSend/getMyAnnouncementSend`, params)
// 省市县级联数据
export const getAddressList = params => getAction(`${ MTC_AUTH }sys/category/getAddressList`, params)
// 获取子集机构,不包含当前登录的code
export const getSonDepartList = params => getAction(`${ MTC_AUTH }sys/sysDepart/getSonDepartList`, params)
// 获取当前用户有权限的部门列表
export const getDepartListByRole = param => getAction(`${ MTC_AUTH }sys/sysDepart/getDepartListByRole`, param)
//查询所有用户，不包括当前用户
export const getQueryUser = params => getAction(`${ MTC_AUTH }sys/user/getQueryUser`, params)
export const getInspectorUser = params => getAction(`${ MTC_AUTH }sys/user/getInspectorUser`, params)


export const getCompanyCodeByConCode = params => getAction(`/calculation/efsStlFormula/getCompanyCodeByConCode`, params)
export const getByCodes = params => getAction(`/calculation/efsStlFormula/getByCodes`, params)
//公式计算
export const addFormula = params => postAction(`/calculation/efsStlFormula/add`, params)
//DelFormula
export const delFormula = params => deleteAction(`/calculation/efsStlFormula/delete`, params)
// 物料信息
export const getMaterialById = params => getAction(`/efsc/masterdata/efsMdMmGroup/getMaterialById`, params)
export const getMaterialsByPlantCode = params => getAction(`/efsc/masterdata/efsMdMmGroup/getMaterialsByPlantCode`, params)
export const getMmByCodeAndPlant = params => getAction(`/efsc/masterdata/efsMdMaterial/getMaterialsByMmCode`, params)
export const getMaterialByMmCodeAndFarmCode = params => getAction(`/efsc/masterdata/efsMdMaterial/getMaterialByMmCodeAndFarmCode`, params)
export const getMaterialInfoByMmCode = params => getAction(`/material/efsMdMaterial/getMaterialInfoByMmCode`, params)
// 查询物料List（包含农场）
export const getMmListNoPage = params => getAction(`/efsc/masterdata/efsMdMaterial/getMmListNoPage`, params)
export const getMaterialList = params => getAction(`/efsc/masterdata/efsMdMaterial/getMaterialList`, params)
// 查询物料List（包含品种）
export const getMmListByVariety = params => getAction(`/efsc/masterdata/efsMdMaterial/getMmListByVariety`, params)
// 单据信息
export const getItemsByOrderId = param => getAction(`/efsc/efsBzOrderItem/getItemsByOrderId`, param)
export const checkAccountPeriod = param => getAction(`/efsc/commonsettings/efsSysAccountPeriod/getCheckAccountPeriod`, param)
// 查询仓库、筒仓list
export const queryWhListByParam = params => getAction(`/efsc/masterdata/efsMdWarehouse/queryWhListByParam`, params)
export const getWareHouseList = params => getAction(`/efsc/masterdata/efsMdWarehouse/getWareHouseList`, params)
//查仓库
export const getWareHouseListByL = params => {
  params = params || {}
  params[ 'whType' ] = 'L'
  return getAction(`/efsc/masterdata/efsMdWarehouse/getWareHouseList`, params)
}
//查仓库
export const getWareHouseListByH = params => {
  params = params || {}
  params[ 'whType' ] = 'H'
  return getAction(`/efsc/masterdata/efsMdWarehouse/getWareHouseList`, params)
}
//查仓库
export const getWareHouseListByI = params => {
  params = params || {}
  params[ 'whType' ] = 'I'
  return getAction(`/efsc/masterdata/efsMdWarehouse/getWareHouseList`, params)
}
// 批次管理
export const queryCurrentBatchByParam = params => getAction(`/efsc/breedmanage/batch/currentInfo`, params)
// 根据栋舍查批次列表
export const getBatchInfoByHouse = params => getAction(`/efsc/breedmanage/batch/getBatchInfo`, params)
// 根据栋舍查批次列表(入舍)
export const breedBatchList = params => getAction(`/efsc/masterdata/efsMdBreedBatch/breedBatchList`, params)
// 根据养殖场查批次列表
export const getBatchInfoByFarm = params => getAction(`/efsc/breedmanage/batch/getBatchInfoByFarm`, params)
// 根据批次编号查询库存
export const getInventoryByBatchCode = params => getAction(`/efsc/breedmanage/batch/getInventoryByBatchCode`, params)
// 库存查询
export const getInventoryList = params => getAction(`/efsc/efsStInventory/listNoPage`, params)
// 通过饲养批次查询物料
export const queryMaterialByBreedBatch = params => getAction(`/efsc/masterdata/efsMdMaterial/queryByBreedBatch`, params)
// 养殖管理-获取转场-转出记录-不分页
export const getTransferOutListNoPage = params => getAction(`/efsc/breedmanage/batch/getTransferOutListNoPage`, params)
// 库存管理-根据农场查询库存
export const getInventoryByFarmCode = params => getAction(`/efsc/efsStInventory/getInventoryByFarmCode`, params)
export const getStockListToSelect = params => getAction(`/efsc/efsStInventory/getStockListToSelect`, params)
// 种蛋复检-根据公司、农场、批次获取种蛋库存
export const getEggStockList = params => getAction(`/efsc/hatchmanage/eggReCheck/getEggStockList`, params)
// 查询仓库、库位供下拉框使用
export const selectWhToUseSelect = params => getAction(`/efsc/masterdata/efsMdWarehouse/selectWhToUseSelect`, params)
// 查询仓库、库位(包含工厂级别的)供下拉框使用
export const selectPlantWhToUseSelect = params => getAction(`/efsc/masterdata/efsMdWarehouse/selectPlantWhToUseSelect`, params)
// efs_md_breed_batch-列表查询(多功能可复用)
export const listSearch = params => getAction(`/efsc/masterdata/efsMdBreedBatch/listNoPage`, params)
// 饲养批次子表-列表查询（无分页）
export const breadBatchSearch = params => getAction(`/efsc/breedstandard/efsMdBreedBatchDetail/listNoPage`, params)
// 通过农场查孵化详情
export const queryItemsByFarmCode = params => getAction(`/efsc/efsBzOrderItem/queryItemsByFarmCode`, params)
// 根据饲养批次查死淘物料
export const listNoPageByBatch = params => getAction(`/breed/efsSysAssoMapping/listNoPageByBatch`, params)
// 根据饲养批次查出栏
export const outBuildingByBatch = params => getAction(`/breed/efsSysAssoMapping/outBuildingByBatch`, params)
// 根据编码查询配置集合
export const getSettingByCode = params => getAction(`/breed/efsSysAssoMapping/listNoPage`, params)
// 查询出雏详细列表
export const getHatchList = params => getAction(`/breedmanage/efsBzOtherOrder/hatchList`, params)
// 饲喂根据仓库查库存-带饲养批次栋舍信息
export const getInventoryListBySloc = params => getAction(`/efsc/breedmanage/feeding/getInventoryList`, params)
//获取种蛋复检配置
export const getInventoryListBySlocCode = params => getAction(`/breed/efsSysAssoMapping/eggReCheckMapping`, params)
// 查询客户/供应商数据
export const getVenOrCustListByOrgcode = param => getAction(`/partner/efsMdPartner/getVenOrCustListByOrgcode`, param)
// 孵化管理-获取出雏记录
export const getHatchingList = param => getAction(`/efsc/hatchmanage/hatch/getHatchingList`, param)
// 通过农场code和养殖方式查询饲养员
export const getBreedByFarmCodeAndBreedPattern = param => getAction(`/efsc/masterdata/efsMdBreedBatch/getBreedByFarmCodeAndBreedPattern`, param)
// 通过农场code和养殖方式查询饲养员
export const getBatchList = param => getAction(`/efsc/hatchmanage/hatch/getBatchList`, param)
//通过编码查询档案
export const getSymptomByCode = params => getAction(`/symptomArchive/efsMdArchives/getSymptomByCode`, params)
//通过脏器编码查询档案
export const getVisceraByCode = params => getAction(`/visceraArchive/efsMdArchives/getVisceraByCode`, params)
//通过治疗方案编码查询档案
export const getTreatmentByCode = params => getAction(`/treatmentArchive/treatmentArchives/getTreatmentByCode`, params)
//通过合同查询养户、养殖场、公司
export const getContractData = params => getAction(`/batchManage/efsMdBreedBatch/getContractData`, params)
export const getQueryData = params => getAction(`/materialPickingPlan/efsMdMaterialPlan/getQueryData`, params)
export const getContractByCode = params => getAction(`/contractPriceList/efsMdContractPriceList/getContractCode`, params)
export const getSettleByConCode = params => getAction(`/settleList/efsStlSettle/querySettleByConCode`, params)
// 根据批次编号查询合同价格清单批次
export const getConfirmByBatchCode = params => getAction(`/settlePickingList/efsStlSettleApply/getMaterByBatchCode`, params)
// 根据mmCode
export const getMtrlCodeWithMaxversion = params => getAction(`/companyPriceList/efsMdCompanyPriceList/queryByMtrlCodeWithMaxversion`, params)
// 通过合同查询物料
export const getMtrlCodeWithByConCode = params => getAction(`/companyPriceList/efsMdCompanyPriceList/queryContractByCode`, params)
//查询服务组数据
export const getServiceGroupData = params => getAction(`/efsc/commonsettings/efsSysAccountPeriod/getServiceGroupData`, params)
export const getCheckServiceGroup = params => getAction(`/stockHistory/efsMdInventoryLog/getCheckServiceGroup`, params)
export const getGroupCode = params => getAction(`/costList/efsCapCost/getGroupCode`, params)
export const getOrderCodeData = params => getAction(`/chickenPickPlan/efsMdPickingPlan/getPickingCodeList`, params)
//物料
export const getSlocCodeData = params => getAction(`/chickenPickPlan/efsMdPickingPlan/getMmCodeList`, params)
export const getApplicationCodeList = params => getAction(`/efsc/efsBzOrder/getApplicationCodeList`, params)
// 新查询客户/供应商数据
export const getVenPartner = param => getAction(`/partner/efsMdPartner/getVenPartner`, param)
//服务部
export const getServiceDepartmentCodeList = params => getAction(`/efsc/efsBzOrder/getServiceDepartmentCodeList`, params)
//养殖场查仓库
export const getSlocCodeList = params => getAction(`/chickenPickPlan/efsMdPickingPlan/getSlocCodeList`, params)
export const getMdGroupPriceList = params => getAction(`/priceList/groupPriceList/efsMdGroupPriceList/getMdGroupPriceList`, params)
// 查询结算批次号
export const getSettleCode = params => getAction(`/efsc/masterdata/efsMdBreedBatch/getSettleCode`, params)
//需要结算的批次号
export const getBreedCodeData = params => getAction(`/settlementReceipt/efsMdBill/getBreedCodeDataList`, params)
export const getVersion = params => getAction(`/companyStandard/efsStdCompanyStandard/getVersion`, params)
export const getCompanyPriceMaterials = params => getAction(`/efsc/pickingreturning/getCompanyPriceMaterials`, params)
//当前公司下的养殖场
export const getFarmCodeList = params => getAction(`/salesPricing/efsMdSalesPricing/getFarmCodeList`, params)